import { render, staticRenderFns } from "./review-likes.vue?vue&type=template&id=10a37734&"
import script from "./review-likes.vue?vue&type=script&lang=js&"
export * from "./review-likes.vue?vue&type=script&lang=js&"
import style0 from "./review-likes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10a37734')) {
      api.createRecord('10a37734', component.options)
    } else {
      api.reload('10a37734', component.options)
    }
    module.hot.accept("./review-likes.vue?vue&type=template&id=10a37734&", function () {
      api.rerender('10a37734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/review-likes.vue"
export default component.exports